import {
  createSlice,
  type PayloadAction,
  type Reducer,
} from '@reduxjs/toolkit';
import { Round, RoundWinner } from '../types';

export const ROUND_SLICE_KEY = 'round';

export interface RoundSliceState<T = unknown> {
  roundId?: string;
  externalRoundId?: string;
  round: Round<T>;
  roundWinner: RoundWinner | undefined;
  availableToBet: boolean;
}

export const createInitialRoundState = <T>(): RoundSliceState<T> => ({
  roundId: undefined,
  externalRoundId: '-',
  round: {} as Round<T>,
  roundWinner: undefined,
  availableToBet: false,
});

const initialState: RoundSliceState = createInitialRoundState();

const roundSlice = createSlice({
  name: ROUND_SLICE_KEY,
  initialState,
  reducers: {
    setRound: (state, action: PayloadAction<Round<unknown>>) => {
      state.round = action.payload;
      state.roundId = action.payload.id;
      state.externalRoundId = action.payload.externalRoundId;
    },
    setRoundWinner: (state, action: PayloadAction<RoundWinner | undefined>) => {
      state.roundWinner = action.payload;
    },
    setAvailableToBet: (state, action: PayloadAction<boolean>) => {
      state.availableToBet = action.payload;
    },
    resetRoundSlice: () => initialState,
  },
});

const roundReducer = roundSlice.reducer as Reducer;

export default roundReducer;

export const roundSelector = (state: { [ROUND_SLICE_KEY]: RoundSliceState }) =>
  state[ROUND_SLICE_KEY];

export const roundActions = roundSlice.actions;
